module.exports = __webpack_public_path__ + "static/media/class (11).ed0c8f12.webp";